import { TripTypes } from '@model/common';
import { DestinationLinkBuilder } from '@model/iceberg';

export interface TourAlternativeItineraryPayload {
  airport?: string;
  alternativeDate: string;
  path: string;
  guests?: number;
  tripType?: TripTypes;
}

export const getAlternativeItineraryLink = (payload: TourAlternativeItineraryPayload) => {
  const { path, airport, alternativeDate, guests, tripType } = payload;
  const linkBuilder = new DestinationLinkBuilder();
  const link = linkBuilder.getTourLink(path, tripType);

  if (!link.as) return '';

  const queryParts: Array<string> = [];

  if (alternativeDate) {
    queryParts.push(`alternativeDate=${alternativeDate}`);
  }

  if (airport) {
    queryParts.push(`airport=${airport}`);
  }

  if (guests) {
    queryParts.push(`adults=${guests || 2}`);
  }

  const queryString = queryParts.join('&');
  const separator = link.as.toString().includes('?') ? '&' : '?';

  return queryString ? `${link.as}${separator}${queryString}` : link.as;
};
